import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Highscore() {

    const [highscores, setHighscores] = React.useState(("memory-highscore" in localStorage) ? JSON.parse(localStorage.getItem("memory-highscore")).sort((a, b) => {
        if (a[0] === b[0]) {
            return a[1] - b[1];
        }
        return a[0] - b[0];
    }) : []
)
/*
    const highscores = ("memory-highscore" in localStorage) ? JSON.parse(localStorage.getItem("memory-highscore")).sort((a, b) => {
        if (a[0] === b[0]) {
            return a[1] - b[1];
        }
        return a[0] - b[0];
    }) : []
*/
    const colors = ["gold", "silver", "brown"]
    const highscoresAmount = highscores.length > 3 ? 2 : highscores.length - 1
    let highscoreList = []
    
    function renderHighscores() {
        for(let i = 0; i <= highscoresAmount; i++) {
            highscoreList.push(
            <p style={{ color: colors[i] }}>
            <span><FontAwesomeIcon icon="fa-solid fa-trophy" /> :</span>
            <span><FontAwesomeIcon icon="fa-solid fa-hand-pointer" /> {highscores[i][0]}</span>
            <span><FontAwesomeIcon icon="fa-solid fa-clock" /> {highscores[i][1]}s</span>
        </p>)
        }
        return highscoreList
    }

    return <>
        <h1>Highscore</h1>
        {console.log(highscores)}
        {console.log(highscoresAmount)}
        {("memory-highscore" in localStorage) ? renderHighscores() : ""}      
        <button className="highscore--reset" 
        onClick={() => {setHighscores([])
            localStorage.clear()}}>Reset</button>
    </>
}
/*<p style={{ color: "gold" }}>
            <FontAwesomeIcon icon="fa-solid fa-trophy" />
            <span><FontAwesomeIcon icon="fa-solid fa-hand-pointer" /> {highscores[0][0]}</span>
            <span><FontAwesomeIcon icon="fa-solid fa-clock" /> {highscores[0][1]}s</span>
        </p>
        <p style={{ color: "silver" }}>
            <FontAwesomeIcon icon="fa-solid fa-trophy" />
            <FontAwesomeIcon icon="fa-solid fa-hand-pointer" /> {highscores[1][0]}
            <FontAwesomeIcon icon="fa-solid fa-clock" /> {highscores[1][1]}s
        </p>
        <p style={{ color: "brown" }}>
            <FontAwesomeIcon icon="fa-solid fa-trophy" />
            <FontAwesomeIcon icon="fa-solid fa-hand-pointer" /> {highscores[2][0]}
            <FontAwesomeIcon icon="fa-solid fa-clock" /> {highscores[2][1]}s
        </p>
*/